import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal, NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';

export interface ProgressStep {
	label: string;
	status: 'pending' | 'active' | 'done' | 'error';
	progress: number;
}

@Component({
	standalone: true,
	selector: 'luzula-progress-modal',
	imports: [CommonModule, NgbProgressbarModule],
	template: `
		<div class="modal-header">
			<h4 class="modal-title">{{ title }}</h4>
		</div>
		<div class="modal-body">
			@for (step of steps(); track step.label) {
				<div class="mb-3">
					<div class="d-flex justify-content-between align-items-center mb-1">
						<span class="fw-bold">
							<i class="bi me-2" [class]="getStatusIcon(step.status)"></i>
							{{ step.label }}
						</span>
						<small class="text-muted">
							@if (step.status === 'done') { Fertig }
							@if (step.status === 'error') { Fehler }
						</small>
					</div>
					<ngb-progressbar
						[type]="getProgressType(step.status)"
						[value]="step.progress"
						[striped]="step.status === 'active'"
						[animated]="step.status === 'active'">
					</ngb-progressbar>
				</div>
			}
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-primary"
				[disabled]="!allDone"
				(click)="activeModal.close()">
				@if (!allDone) {
					<span class="spinner-border spinner-border-sm me-2" role="status"></span>
					Bitte warten...
				} @else {
					Schließen
				}
			</button>
		</div>
	`,
})
export class ProgressModalComponent {
	title = 'Vorgang läuft';
	steps = signal<ProgressStep[]>([]);

	constructor(public activeModal: NgbActiveModal) {}

	get allDone(): boolean {
		const s = this.steps();
		return s.length > 0 && s.every(st => st.status === 'done' || st.status === 'error');
	}

	getStatusIcon(status: ProgressStep['status']): string {
		switch (status) {
			case 'pending': return 'bi-hourglass';
			case 'active': return 'bi-arrow-repeat';
			case 'done': return 'bi-check-circle-fill text-success';
			case 'error': return 'bi-x-circle-fill text-danger';
		}
	}

	getProgressType(status: ProgressStep['status']): string {
		switch (status) {
			case 'error': return 'danger';
			case 'done': return 'success';
			default: return 'primary';
		}
	}
}
